<template>
  <v-row>
    <v-toolbar flat color="accent lighten-4" class="white--text">
      <v-toolbar-title v-if="city" class="text-center font-weight-bold pa-3">
        {{ city.name }} 
        <template v-if="city.code_postal">
          {{ city.code_postal.slice(0, 2) }}
        </template>
        {{ city.paysIso2 }} 

        <template v-if="$default_model">
          (modèle {{ $default_model || '' }})
        </template>
      </v-toolbar-title>
      <v-spacer />
      <template v-if="authorizedWM.includes($wm.title)">
      <v-tooltip top v-if="!canSubscribe && !isBulletinSubscribe && isLogged">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small :loading="loadingBulletin" v-bind="attrs" v-on="on" @click="subscribeBulletin"
              :disabled="!canSubscribe" elevation="0"><v-icon small>mdi-lock</v-icon></v-btn>
          </template>
          <span>{{ $t("forecasts.btnBar.bulletin.limit") }}</span>
        </v-tooltip>
        <template v-else-if="isLogged">
          <v-tooltip top>
            <template v-slot:activator="{ on, attr }">
              <v-btn v-on="on" v-bind="attr" small id="v-step-5" :loading="loadingBulletin"
                :color="isBulletinSubscribe ? 'primary' : ''" class="mx-1" @click="
                  isBulletinSubscribe
                    ? unsubscribeBulletin()
                    : subscribeBulletin()
                " elevation="0">
                <template v-if="isBulletinSubscribe">
                  <v-icon small>mdi-email</v-icon>
                </template>
                <template v-else>
                  <v-icon small>mdi-email</v-icon>
                </template>
              </v-btn>
            </template>
            <span>{{ $t("email_bulletin_pdf") }}</span>
          </v-tooltip>
        </template>
      </template>
        <v-tooltip top v-if="!isSubscribe">
          <template v-slot:activator="{ on, attr }">
            <v-btn small v-on="on" v-bind="attr" id="v-step-4" elevation="0" :loading="loading"  @click="isLogged ?subs() : $router.push(`/login?redirect=forecasts/${$route.params.geoname}/${$route.params.cityname}/resum`)">
              <v-icon small>mdi-heart-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("add_to_favorites") }}</span>
        </v-tooltip>
        <v-tooltip top v-else>
          <template v-slot:activator="{ on, attr }">
            <v-btn small class="mr-1" v-on="on" v-bind="attr" :loading="loading" elevation="0" right color="primary"
              @click="unsubs()"><v-icon small>mdi-heart</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("delete_from_favorites") }}</span>
        </v-tooltip>
        <v-tooltip top v-if="authorizedWM.includes($wm.title)">
          <template v-slot:activator="{ on, attr }">
            <v-btn class="ml-1" v-on="on" v-bind="attr" small id="v-step-6" elevation="0" exact exact-active-class="info"
              :to="`/forecasts/alerts/${$route.params.geoname}/${$route.params.cityname}`"><v-icon
                small>mdi-bell</v-icon></v-btn>
          </template>
          <span>{{ $t("forecasts.btnBar.alertsLevels") }}</span>
        </v-tooltip>
      <template v-slot:extension>
        <v-tabs v-model="currentItem" show-arrows slider-color="primary">
          <v-tab exact :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/resum`">
            Résumé
          </v-tab>
          <v-tab exact :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}`">
            <template v-if="user.features.find((map) => map == 'forecast_7')">
              14
            </template>
            Horaire
          </v-tab>

          <v-tab exact :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/multichart`">
                Comparaison modèles
          </v-tab>
          <v-tab
            v-if="user.features.find((map) => map == 'roadcast') && parseInt(moment().format('MM')) >= 5 && parseInt(moment().format('MM')) <= 10"
            :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/roadcast`">
            Viabilité Hivernale
          </v-tab>
        </v-tabs> <br>
      </template>
    </v-toolbar>
    <v-col cols="12" v-if="$route.path == `/forecasts/${$route.params.geoname}/${$route.params.cityname}/multichart` || $route.path == `/forecasts/${$route.params.geoname}/${$route.params.cityname}/multi`">
      <v-tabs color="accent ligthen-4" style="color:black!important;" slider-color="white" v-model="currentItem">
            <v-tab exact exact-active-class="primary" style="color:black!important;" :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/multichart`" class="black--text">Graphique</v-tab>
            <v-tab exact exact-active-class="primary" style="color:black!important;" :to="`/forecasts/${$route.params.geoname}/${$route.params.cityname}/multi`" class="black--text">Tableau</v-tab>
          </v-tabs>
      </v-col>

    <v-tabs-items v-model="currentItem" >
      <v-tab-item v-for="item in items.concat(more)" :key="item" :value="'tab-' + item">
        <v-card flat>
          <v-card-text>
            <h2>{{ item }}</h2>
            {{ text }}
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <v-col cols="12" class="py-0">
      <v-container fluid class="px-0 mx-0">
        <keep-alive max="5">
          <router-view />
        </keep-alive>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
// Store
import { mapState } from "vuex";

// API
import api from "@/api";
import moment from 'moment'

export default {
  computed: {
    bulletin_phenomenes() {
      if (!this.bulletin) "";
      return this.bulletin.bulletin_phenomenes.replace(
        /(?:\r\n|\r|\n)/g,
        "<br />"
      );
    },
    bulletin_synop() {
      if (!this.bulletin) "";
      return this.bulletin.bulletin_synop.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    ...mapState(["user", "model","isLogged"]),

    // User geoname subscribe check
    isSubscribe() {
      return !!this.user.favoris.find(
        (favorite) => favorite.id_ville == this.$route.params.geoname
      );
    },

    canSubscribe() {
      let limit = this.$checkLimit("bulletins_pdf");

      if (!this.user.features.find((feature) => feature == 'bulletins_pdf'))
      {
        return false;
      }

      if (!limit) {
        limit = 1;
      }

      return this.user.bulletins_pdf.length < limit;
    },

    currentfav() {
      const find = this.user.favoris.find(
        (favorite) => favorite.id_ville == this.$route.params.geoname
      );

      return find ? find : false;
    },

    // User bulletin subscribe check
    isBulletinSubscribe() {
      return this.user.bulletins_pdf.find(
        (report) => report.geoname == this.$route.params.geoname
      );
    },
  },

  methods: {
    async getWeatherModels() {
      const models_available = [];
      const models = await api.weather.getModels(this.$route.params.geoname);

      Object.entries(models).forEach((element) => {
        if (element[1]) {
          if (element[0].indexOf("gfs") && !models_available.includes("gfs")) {
            models_available.push("gfs");
          } else {
            models_available.push(element[0]);
          }
        }
      });
      this.weather_models = models_available;
    },
    async getBulletin() {
      try {
        this.bulletin = await api.bulletin.get(this.$route.params.cityname);
      } catch (err) {
        console.error(err.message);
      }
    },
    async getAlerts() {
      try {
        let res = await api.forecast.getAlerts(
          this.user.id_user,
          this.$route.params.geoname
        );
        
        const keys = [];

        res.forEach((element) => {
          element.alerts.forEach((alert) => {
            keys.push(alert.key);
          });
        });

        const uniq = [...new Set(keys)];

        res = res.slice(1, 8);

        this.keys = uniq;
      } catch (err) {
        console.error(err.message);
      }
    },
    async subs() {
      this.loading = true;
      try {
        await api.users.subsfavorite(this.user.id_user, {
          id_ville: this.$route.params.geoname,
          name: this.$route.params.cityname,
        });

        const user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
    },

    async unsubs() {
      this.loading = true;
      try {
        await api.users.unsubsfavorite(
          this.user.id_user,
          this.currentfav.id_favoris
        );

        const user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
    },

    async subscribeBulletin() {
      this.loadingBulletin = true;
      try {
        await api.bulletin.subscribe(this.user.id_user, {
          geoname: this.$route.params.geoname,
          city_name: this.$route.params.cityname,
        });

        const user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
        this.subscribeBulletinMessage = true;
      } catch (err) {
        console.error(err.message);
      }
      this.loadingBulletin = false;
    },

    async unsubscribeBulletin() {
      this.loadingBulletin = true;
      try {
        await api.bulletin.unsubscribe(
          this.user.id_user,
          this.isBulletinSubscribe.id
        );

        const user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loadingBulletin = false;
    },
  },

  data() {
    return {
      currentItem: 'tab-Web',
      items: [
        'Web', 'Shopping', 'Videos', 'Images',
      ],
      more: [
        'News', 'Maps', 'Books', 'Flights', 'Apps',
      ],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      city: null,
      lat: 47,
      authorizedWM: ['pm', 'fp'],
      lon: 2,
      moment,
      weather_models: [],
      selectedModel: null,
      cogOpen: null,
      myOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Terminer",
        },
      },
      selectedMobileMenu: null,
      subscribeBulletinMessage: false,
      loading: false,
      loadingBulletin: false,
      bulletin: null,
      detail: false,
      keys: [],
      steps: [
        {
          target: "#v-step-4", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Pour ajouter cette ville en favoris, cliquez ici`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-5", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Vous pouvez aussi vous abonnez au bulletin météo pour les recevoirs sur votre boite mail`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
        {
          target: "#v-step-6", // We're using document.querySelector() under the hood
          header: {
            title: `Présentation ${this.$wm.title}`,
          },
          content: `Configurez des alertes pour votre ville afin d'être prévenu quand un phénomène ce produit`,
          params: {
            placement: "bottom", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
          },
        },
      ],
    };
  },

  async mounted() {
    if (!localStorage.getItem("localtour2")) {
      localStorage.setItem("localtour2", true);
      this.$tours["myTour2"].start();
    }

    if (!this.$route.params.geoname) {
      this.$router.push("/");
      return;
    }

    if (this.$route.query.id) {
      const infos = await api.cities.getinfos(this.$route.query.id);
      this.$router.push(
        `/forecasts/${this.$route.query.id}/${infos.name}/resum`
      );
      return;
    }

    this.city = await api.cities.getinfos(this.$route.params.geoname);

    // this.getBulletin();
    this.selectedModel = this.model;
    this.getWeatherModels();
    this.getAlerts();
  },
  watch: {
    selectedModel() {
      this.$store.dispatch("setModel", this.selectedModel);
    },
    $route: {
      deep: true,
      handler() {
        try{
          this.getBulletin();
        }catch(err){
          console.log(err)
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab, button.align-self-center.mr-4.v-btn.v-btn--text.theme--light.v-size--default {
  color:white!important;
}
</style>
